import React, { Component } from 'react';
import { connect } from 'react-redux';

import awbRemote from '../../api/awbRemote';
import { baseUrl } from '../../api/baseUrl';

import { receiveError } from '../../store/actions/notificationAction';

import ApiResponse from '../../models/ApiResponse';
import ResponseError from '../../models/ResponseError';
import PickupOrder from '../../models/PickupOrderGha';
import AwbParams from '../../models/AwbParams';
import validation from "../../utils/validation";

import { extractAwbCodeAndNumber } from '../../utils/airwayBill';

import PoDModalContainer from '../poD/PoDModalContainer';
import AttachmentsContainer from '../attachments/AttachmentsContainer';
import ReadyForCarriageCheckContainer from '../readyForCarriageCheck/ReadyForCarriageCheckContainer';
import PaymentAwbInfo from '../../models/PaymentAwbInfo';
import ShipmentInventoryFilterComponent from './shipmentInventoryFilter';

import AwbInfoComponent from './awbInfoComponent';
import { SEARCH_OPTIONS_SCHEMA } from '../../utils/inventorySearchOptions';
import { Moment } from 'moment';
import InventorySearchOptions from '../../models/InventorySearchOptions';
import OrderExceptionNoteContainer from '../awbInfo/orderExceprionNote/OrderExceptionNoteContainer';
import AwbReportContainer from '../awbInfo/awbReport/awbReportContainer';
import ShipmentInventory from '../../models/ShipmentInventory';
import ShimpmentInventoryResponse from '../../models/ShipmentInventoryResponse';

import commonStyles from '../common/common.module.css';
import MultipleAwbs from '../awbInfo/MultipleAwbs';
import Awb from '../../models/Awb';
import User from '../../models/User';

interface ShipmentInventoryContainerProps {
  receiveError: (error: ResponseError) => void;
  buttonState: boolean;
  user: User;
}

interface ShipmentInventoryContainerState {
  poAwbs: Array<ShipmentInventory>;
  awb: Array<any>;
  paymentInfo: Array<PaymentAwbInfo>;
  pickupOrders: Array<PickupOrder>;
  isModalPoDOpen: boolean;
  flightFilter: Array<string>;
  flightVal: string;
  view: string;
  awbCode: string;
  awbNumber: string;
  awbVersion: number;
  keyword: string;
  isAttachmentsDialogOpen: boolean;
  tempSearchOptions: InventorySearchOptions;
  searchOptions: InventorySearchOptions;
  isRForCheckDialogOpen: boolean;
  orderNumber: string;
  isOrderNoteDialogOpen: boolean;
  isAwbReportDialogOpen: boolean;
  orderType: string;
  piecesDimmed: number;
  multipleAwbModal: boolean;
  multipleAwbs: Array<Awb>;
  selectedAwb: Awb;
}

class ShipmentInventoryContainer extends Component<ShipmentInventoryContainerProps,	ShipmentInventoryContainerState> {
  state: ShipmentInventoryContainerState = {
    poAwbs: [],
    awb: [],
    flightFilter: [],
    flightVal: 'Flight',
    view: 'render',
    orderType: '',
    tempSearchOptions: SEARCH_OPTIONS_SCHEMA,
    searchOptions: SEARCH_OPTIONS_SCHEMA,
    paymentInfo: [],
    pickupOrders: [],
    isModalPoDOpen: false,
    awbCode: '',
    awbNumber: '',
    keyword: '',
    isAttachmentsDialogOpen: false,
    isRForCheckDialogOpen: false,
    orderNumber: '',
    isOrderNoteDialogOpen: false,
    isAwbReportDialogOpen: false,
    piecesDimmed: 0,
    multipleAwbModal: false,
    multipleAwbs: [],
    awbVersion: 0,
    selectedAwb: {} as Awb
  };

  searchAwb = (): void => {
    const searchOptions: InventorySearchOptions = {...this.state.tempSearchOptions};

    if (
      searchOptions.keyword &&
      searchOptions.keyword !== '' &&
      searchOptions.keyword.length >= 3
    ) {
      searchOptions.ignoreDateAndTime = true;
    }

    if (
      searchOptions.keyword &&
      searchOptions.keyword !== '' &&
      searchOptions.keyword.length < 3
    ) {
      searchOptions.errorKeyword = true;
    }

    this.setState({ searchOptions }, () => {
      this.getAwbs();
    });
  };

  getAwbs = (): void => {
    const orderType: string = this.state.orderType;
    let searchOptions: InventorySearchOptions = { ...this.state.searchOptions };
    let startDate: string = searchOptions.startDate.format('YYYYMMDD');
    let endDate: string = searchOptions.endDate.format('YYYYMMDD');
    let startTime: string = searchOptions.startTime.format('hh:mm');
    let endTime: string = searchOptions.endTime.format('hh:mm');
    const awbKey = this.state.keyword;
    if (validation.validateAWB(awbKey)) {
    const awbParams: AwbParams = extractAwbCodeAndNumber(awbKey);
    const keyword = awbParams.awbCode + '-' + awbParams.awbNumber;
    if (
      searchOptions.ignoreDateAndTime &&
      searchOptions.ignoreDateAndTime === true
    ) {
      startDate = '';
      endDate = '';
      startTime = '';
      endTime = '';
    }
    this.setState({ awb: [], piecesDimmed: 0 });
    awbRemote
      .getShipmentInventoryOrders(
        orderType,
        startDate,
        endDate,
        startTime,
        endTime,
        keyword,
        this.state.awbVersion
      )
      .then((res: ApiResponse<ShimpmentInventoryResponse>) => {
        const result: ShimpmentInventoryResponse | undefined = res.result;
        const error: ResponseError | undefined = res.error;

        if (result) {
          let pieces = 0;
          result.poAwb.orderAwb.cwt_data.data.forEach((pc: any) => {
            pieces += pc.pieces;
          })
          this.setState({
            poAwbs: result.getPOQuery,
            awb: [result.poAwb],
            piecesDimmed: pieces
          });
        }
        if (error) {
          this.props.receiveError(error);
        }
      });
       } else {
      const errObj: ResponseError = {
        errorCode: "",
        longDescription:
          "The entered value should contain a code (3 digits) and a number (8 digits) separated by a dash (-)!",
      };
      this.props.receiveError(errObj);
    }
  };

  handleChangeDate = (type: string, date: Moment): void => {
    const searchOptions: InventorySearchOptions = {
      ...this.state.tempSearchOptions,
    };

    switch (type) {
      case 'startDate':
        searchOptions.startDate = date;
        break;
      case 'endDate':
        searchOptions.endDate = date;
        break;
      default:
        break;
    }

    this.setState({ tempSearchOptions: searchOptions });
  };

  disabledDate = (): void => {
    const searchOptions: InventorySearchOptions = {
      ...this.state.tempSearchOptions,
    };
    searchOptions.currDate = true;

    this.setState({ tempSearchOptions: searchOptions });
  };

  changeOrderType = (event: any): void => {
    this.setState({ orderType: event.target.value });
  };

  changeFocuses = (): void => {
    const searchOptions: InventorySearchOptions = {
      ...this.state.tempSearchOptions,
    };

    searchOptions.errorKeyword = false;

    if (searchOptions.keyword === '') {
      searchOptions.currDate = false;
    }

    this.setState({ tempSearchOptions: searchOptions });
  };

  print = (): void => {
    this.setState({ view: 'print' }, () => {
      window.print();
      this.setState({ view: 'render' });
    });
  };

  search = (): void => {
    
    if (validation.validateAWB(this.state.keyword)) {
      awbRemote.getAwbs(this.state.keyword).then(resp => {
        const awbsInfo: any | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;

        if (error) {
          this.props.receiveError(error);
        }
        if(!awbsInfo) {
          return;
        }
        if (awbsInfo.awbs.length < 2) {
          this.searchAwb();
        }

        if (awbsInfo.awbs.length > 1) {
          this.setState({ multipleAwbModal: true, multipleAwbs: awbsInfo.awbs });
        }
      });
    }
  }

  handleChangeKeyword = (event: any): void => {
    let value: string = event.target.value.toString();
    if (value.length === 3 && this.state.keyword.length === 2) {
      value = value + "-";
    }
    if (value.length === 11) {
      if (value.indexOf("-") < 0) {
        value = value.slice(0, 3) + "-" + value.slice(3);
      }
    }
    if (value.split("-").length > 2) {
      return;
    }
    this.setState({ keyword: value });
  };
  
  handleOpenModal = (modalType: string, code: string, number: string, awbVersion: number, orderNumber?: string): void => {
    switch (modalType) {
      case 'pod':
        this.setState({ awbCode: code, awbNumber: number, awbVersion, isModalPoDOpen: true });
        break;
      case 'attachments':
        this.setState({
          awbCode: code,
          awbNumber: number,
          awbVersion,
          isAttachmentsDialogOpen: true,
        });
        break;
      case 'rForCheck':
        this.setState({
          isRForCheckDialogOpen: true,
          awbCode: code,
          awbNumber: number,
          awbVersion,
          orderNumber: orderNumber ? orderNumber : '',
        });
        break;
      case 'orderNote':
        this.setState({ 
          isOrderNoteDialogOpen: true,
          orderNumber: orderNumber ? orderNumber : '',
        });
        break;
      default:
        break;
    }
  };

  handleOpenAwbReportModal = (orderNumber: string, orderType: string, code: string, number: string): void => {
    const url: string = `${baseUrl}awb/${code}/${number}/${this.state.awbVersion}/exception/file`;
    window.open(url);
  };

  handleClick = (): void => {
    const searchOptions: InventorySearchOptions = {
      ...this.state.tempSearchOptions,
    };
    searchOptions.keyword = '';
    searchOptions.currDate = false;

    this.setState({ tempSearchOptions: searchOptions });
  };


  confirmAwb = (): void => {
    const awb = this.state.selectedAwb;
    this.setState({ awbVersion: awb.version, multipleAwbModal: false }, () => {
      this.getAwbs();
    });
  }

  selectAwb = (awb: Awb): void => {
    this.setState({ selectedAwb: awb, awbVersion: awb.version });
  }

  handleCloseModal = (modalType: string): void => {
    switch (modalType) {
      case 'pod':
        this.setState({ isModalPoDOpen: false });
        break;
      case 'attachments':
        this.setState({ isAttachmentsDialogOpen: false });
        break;
      case 'rForCheck':
        this.setState({ isRForCheckDialogOpen: false, orderNumber: '' });
        break;
      case 'orderNote':
        this.setState({ isOrderNoteDialogOpen: false, orderNumber: ' ' });
        break;
      case 'awbReport':
        this.setState({
          isAwbReportDialogOpen: false,
          orderNumber: '',
          orderType: '',
        });
        break;
      default:
        break;
    }
  };

  printOrder = (orderNumber: string, code: string, number: string) => {
    this.setState({ awbCode: code, awbNumber: number, orderNumber }, () => {
      const url: string = `${baseUrl}pickup_order/${orderNumber}/awb/${this.state.awbCode}/${this.state.awbNumber}/${this.state.awbVersion}/file`;
      window.open(url);
    });
  };

  render() {
    const awbInfo: any = this.state.awb.map((item: ShipmentInventory) => {
      return (
        <AwbInfoComponent
          awb={ [item.info] }
          truckerInfo={ item.driverDetails }
          orderInfo={ item.orderAwb }
          dimensions={ item.orderAwb.cwt_data.data } 
          screening={ item.screening }
          handleOpenModal={ this.handleOpenModal }
          handleOpenAwbReportModal={ this.handleOpenAwbReportModal }
          printOrder={ this.printOrder }
          forwarder={ item.forwarder }
          piecesDimmed={ this.state.piecesDimmed }
        />
      );
    });
    return (
      <div>
        <div className= { commonStyles.headerDummyDiv }> </div>
        <ShipmentInventoryFilterComponent
          startDate={ this.state.tempSearchOptions.startDate }
          endDate={ this.state.tempSearchOptions.endDate }
          startTime={ this.state.tempSearchOptions.startTime }
          endTime={ this.state.tempSearchOptions.endTime }
          flightVal={ this.state.flightVal }
          orderType={ this.state.orderType }
          handleOrderChange={ this.changeOrderType }
          awbNumber={ this.state.keyword }
          print={ this.print }
          search={ this.search }
          handleClick={ this.handleClick }
          keyword={ this.state.tempSearchOptions.keyword }
          errorKeyword={ this.state.tempSearchOptions.errorKeyword }
          disabledDate={ this.disabledDate }
          currDate={ this.state.tempSearchOptions.currDate }
          changeFocuses={ this.changeFocuses }
          handleChangeKeyword={ this.handleChangeKeyword }
          flightFilter={ this.state.flightFilter }
          handleChangeDate={ this.handleChangeDate }
          buttonState={ this.props.buttonState }
        />

        {awbInfo}

        {this.state.isModalPoDOpen && (
          <PoDModalContainer
            isModalOpen={ this.state.isModalPoDOpen }
            handleCloseModal={ this.handleCloseModal }
            code={ this.state.awbCode }
            number={ this.state.awbNumber }
            orderNumber={ this.state.orderNumber }
            version={ this.state.awbVersion }
          />
        )}

        {this.state.isAttachmentsDialogOpen && (
          <AttachmentsContainer
            code={ this.state.awbCode }
            number={ this.state.awbNumber }
            version={ this.state.awbVersion }
            process='export'
            closeAttachments={ () => this.handleCloseModal('attachments') }
            refreshAwbs={ true }
            onlyRead={ true }
          />
        )}

        {this.state.isRForCheckDialogOpen && (
          <ReadyForCarriageCheckContainer
            doNumber={ this.state.orderNumber }
            code={ this.state.awbCode }
            number={ this.state.awbNumber }
            version={ this.state.awbVersion }
            handleClose={ () => this.handleCloseModal('rForCheck') }
            onlyRead={ true }
          />
        )}

        {this.state.isOrderNoteDialogOpen && (
          <OrderExceptionNoteContainer
            number={ this.state.orderNumber }
            handleClose={ this.handleCloseModal }
          />
        )}

        {this.state.isAwbReportDialogOpen && (
          <AwbReportContainer
            type={ this.state.orderType }
            code={ this.state.awbCode }
            number={ this.state.awbNumber }
            orderNumber={ this.state.orderNumber }
            handleClose={ this.handleCloseModal }
          />
        )}

        { this.state.multipleAwbModal && 
          <MultipleAwbs 
            modalOpen={ this.state.multipleAwbModal }
            handleClose={ this.handleCloseModal }
            awbHistory={ this.state.multipleAwbs }
            proceed={ this.confirmAwb }
            selectAwb={ this.selectAwb }
            awb={ this.state.selectedAwb }
            user={ this.props.user }
          />
        }
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    user: state.user,
    buttonState: state.buttonState
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShipmentInventoryContainer);
